import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getLabel } from '../../data/labels';

function CustomAliasesToggle(props) {
    const betslipContext = useContext(BetslipContext);

    return (
        <div>
            <label className="custom-switch-2">
                <input id="customAliasesBtn" type="checkbox" onChange={() => betslipContext.toggleCustomAliases()} checked={betslipContext.enableCustomAliases}></input>
                <span className="custom-slider-2 round"></span>
            </label>
            <span className="ml-2">{getLabel('carrello.enable_custom_aliases')}</span>
        </div>
    );
}

export default CustomAliasesToggle;